/* Mount frame configurations from Shopify theme blocks into matching gallery slides. */
(() => {
  if (window.lumityGalleryFrameInit) return;
  window.lumityGalleryFrameInit = true;

  function renderFrames() {
    // Scope everything to the same Shopify section to avoid cross-product collisions.
    document.querySelectorAll('.shopify-section').forEach(section => {
      const gallery = section.querySelector('product-gallery');
      if (!gallery) return;

      // Clear only the frames created by this script; badges are not touched.
      gallery.querySelectorAll('.gallery-frame[data-gallery-frame-mounted]')
        .forEach(frame => frame.remove());

      section.querySelectorAll('gallery-frame-config').forEach(config => {
        const position = config.dataset.mediaPosition;
        const target = Array.from(
          gallery.querySelectorAll('gallery-badge-container[data-media-position]')
        ).find(el => el.dataset.mediaPosition === position);
        const slide = target?.closest('.product-gallery__media');
        const original = config.querySelector('.gallery-frame');
        if (!slide || !original) return;

        const frame = original.cloneNode(true);
        frame.dataset.galleryFrameMounted = config.dataset.frameId || 'true';
        slide.appendChild(frame);
      });
    });
  }

  let scheduled = false;
  function scheduleRender() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      renderFrames();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRender, { once: true });
  } else {
    scheduleRender();
  }

  document.addEventListener('shopify:section:load', scheduleRender);
  document.addEventListener('shopify:block:select', scheduleRender);
  document.addEventListener('shopify:block:deselect', scheduleRender);
  document.addEventListener('shopify:section:reorder', scheduleRender);
})();
